import { GET_ALL_FILAS, GET_ALL_PAUSAS, GET_ALL_RAMAIS, GET_ALL_OPERADORES } from './mutation-types'
import monitorCallCenterHttpService from '../_services/monitorCallCenterHttpService'

export default {
  listarPausas: async ({ commit }) => {
    try {
      const response = await monitorCallCenterHttpService.getPausas()
      commit(GET_ALL_PAUSAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarFilas: async ({ commit }) => {
    try {
      const response = await monitorCallCenterHttpService.getFilas()
      commit(GET_ALL_FILAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRamais: async ({ commit }) => {
    try {
      const response = await monitorCallCenterHttpService.getRamais()
      commit(GET_ALL_RAMAIS, response.data.ramais)
    } catch (e) {
      console.log(e)
    }
  },
  listarOperadores: async ({ commit }) => {
    try {
      const response = await monitorCallCenterHttpService.getOperadores()
      commit(GET_ALL_OPERADORES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
